import React from 'react'
import './spinner.scss'

const Spinner = () => {
  return (
    <div className='container'>
      <div className='spinner'></div>
    </div>
  )
}

export default Spinner
